export default '2.10.5';


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/newton/wp-content/themes/newton/node_modules/instantsearch.js/es/lib/version.js
// module id = 268
// module chunks = 0